import GetMultipleComponent from "./GetMultipleComponent";

export default GetMultipleComponent;
